import { InvProgrammeView } from '@elva/ui';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Settings › Invisalign Coordinator › The programme (amendment 33 §1). A
 * full-width page (no settings sub-nav); `:step` selects the message, and
 * `replies` scrolls to the Invis-Line replies.
 */
export function SettingsInvisProgrammePage() {
  const navigate = useNavigate();
  const { step } = useParams<{ step: string }>();
  const current = step ?? 'email-1';

  useEffect(() => {
    if (current === 'replies') {
      document.getElementById('replies')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [current]);

  return (
    <InvProgrammeView
      step={current === 'replies' ? 'email-1' : current}
      onSelectStep={(s) => { void navigate(`/settings/ai/invisalign/programme/${s}`); }}
      onBack={() => { void navigate('/settings/ai/invisalign'); }}
    />
  );
}
